import { endOfDay, startOfDay, startOfMonth, subDays } from "date-fns";
// convert camera model names, K220 converts to FV220
export const CONVERT_CAMERA_MODEL_NAMES = true;

export const all_columns = [
  "Camera ID",
  "Asset ID",
  "Asset Description",
  "Display Name",
  "Driver",
  // "Groups",
  "Model",
  "Status",
  "Actions",
];

export const all_columns_widget = [
  "Camera ID",
  "Asset ID",
  "Asset Description",
  "Display Name",
  "Driver",
  "Status",
  "Live View",
];

export const DASH_CAMERA_LISTING_COLUMNS = ["Camera ID", "Status", "Last View"];

export const DASH_HIGHLIGHT_LISTING = [
  "Event Type",
  "Driver",
  "Camera ID",
  "Assets ID",
  "Groups",
  "Date & Time",
];

export const STATUS_OPTIONS = [
  { label: "Live", value: "live" },
  { label: "Standby", value: "standby" },
  { label: "Not Initiated", value: "not_initiated" },
  { label: "Not Reporting", value: "not_reporting" },
];

export const FLEET_HIGHLIGHT_FILTER_OPTIONS = [
  { label: "Last 14 days", value: "0" },
  { label: "Last 7 days", value: "1" },
];

export const CAMERA_IDS = {
  front: "C_F",
  in_cabin: "C_I",
  rear: "C_R",
  extended: "C_E",
};

export enum CAMERA_ID_TYPES {
  front = "C_F",
  in_cabin = "C_I",
  rear = "C_R",
  extended = "C_E",
}

export enum CAMERA_CAPTURE_MODES {
  front = "C_F",
  in_cabin = "C_I",
  rear = "C_R",
  extended = "C_E",
  grid = "GRID",
  combined = "S_F_I",
}

export const ALL_CAMERA_CLIP_TYPES = [
  {
    label: "Side By Side",
    value: CAMERA_CAPTURE_MODES.combined,
  },
  {
    label: "Front Camera",
    value: CAMERA_ID_TYPES.front,
  },
  {
    label: "In Cabin Camera",
    value: CAMERA_ID_TYPES.in_cabin,
  },
  {
    label: "AUX USB Camera",
    value: CAMERA_ID_TYPES.rear,
  },
  {
    label: "AUX TVI Camera",
    value: CAMERA_ID_TYPES.extended,
  },

  {
    label: "GRID",
    value: CAMERA_CAPTURE_MODES.grid,
  },
];

export enum CONNECTIVITY_STATE {
  online = "online",
  offline = "offline",
  standby = "standby",
  waking_up = "waking_up",
}

export enum REPORT_FILTER_BY_OPTION_VALUES {
  GROUP = "1",
  CAMERA = "2",
}

export enum SIGNAL_STATUS_OPTIONS {
  no_signal = "No Signal",
  good = "Good",
}

export const all_columns_file_retrieval = [
  "Snapshots",
  "Camera ID",
  "Asset ID",
  "Asset Description",
  "Display Name",
  "Driver",
  "Retrieval Date and Time",
  "Status",
  "Recording Start Time",
];

export const FILE_RETRIEVEL_STATE_TASK: Record<number, any> = {
  0: { label: "Upcoming", color: "text-field-intermediate" },
  1: { label: "Processing", color: "text-field-intermediate" },
  2: { label: "Success", color: "text-field-success" },
  3: { label: "Failed", color: "text-field-error-dark" },
  4: { label: "Clipping File", color: "text-field-intermediate" },
  5: { label: "Uploading File", color: "text-field-intermediate" },
  6: { label: "Partial Success", color: "text-field-intermediate" },
};

export const FILE_RETRIEVAL_TASK_STATUS_FILTER_OPTIONS = [
  { label: "Upcoming", value: "0" },
  { label: "Processing", value: "1" },
  { label: "Success", value: "2" },
  { label: "Failed", value: "3" },
  { label: "Clipping File", value: "4" },
  { label: "Uploading File", value: "5" },
  { label: "Partial Success", value: "6" },
];

export const PredefinedRanges=(nowInAccountTimezone:Date) => [
  {
    label: "Today",
    value: [startOfDay(nowInAccountTimezone), nowInAccountTimezone] as [Date, Date],
  },
  {
    label: "Last 7 Days",
    value: [subDays(startOfDay(nowInAccountTimezone), 6), endOfDay(nowInAccountTimezone)
    ] as [Date, Date],
  },
  {
    label: "This Month",
    value: [
      startOfMonth(nowInAccountTimezone), endOfDay(nowInAccountTimezone)
    ] as [Date, Date],
  },
];

export const SPEED_UNIT_OPTIONS = [
  { label: "KPH", value: "kph" },
  { label: "MPH", value: "mph" },
];

export const PARKING_PHOTO_OPTIONS = [
  { label: "ALL", value: "ALL" },
  { label: "Road-facing", value: "OUTWARD" },
  // { label: "Driver-facing", value: "INWARD"},
  // { label: "Third", value: "THIRD"},
  { label: "OFF", value: "OFF" },
];

export const AUDIO_ALERT_LANGUAGE_OPTIONS = [
  { label: "English (US)", value: "en-US" },
  { label: "English (Great Britian)", value: "en-GB" },
  { label: "English (Australia)", value: "en-AU" },
  { label: "Spanish", value: "es-ES" },
  { label: "French (France)", value: "fr-FR" },
  { label: "French (Canada)", value: "fr-CA" },
  { label: "Portuguese (Portugal)", value: "pt-PT" },
  { label: "Portuguese (Brazil)", value: "pt-BR" },
  { label: "Traditional Chinese", value: "zh-TW" },
  { label: "Japanese", value: "ja-JP" },
];

export const VIDEO_FORMAT_OPTIONS = [
  { label: "Side By Side", value: "Side-By-Side" },
  { label: "Separate", value: "Separate" },
];

export const VIDEO_RECORDING_CONSTANTS = {
  embedded_separate_video_resolution: "1280x720",
  embedded_side_by_side_video_resolution: "2560x720",
  tvi_four_camera_sku_resolution: "2560x1440",
  tvi_two_camera_sku_resolution: "2560x720",
  uvc_camera_video_resolution: "1280x720",
};

export const STEP_LABELS_OPTIONS = [
  "Low Less Event",
  "Sensitivity",
  "High Less Event",
];

export const STEP_VALUES = {
  min: 0,
  max: 2,
  step: 1,
};

export const SPEED_THRESOLD_OPTIONS = [
  { label: "above 0 kph (0 mph)", value: "0" },
  { label: "above 5 kph (3.1 mph)", value: "5" },
  { label: "above 10 kph (6.2 mph)", value: "10" },
  { label: "above 15 kph (9.3 mph)", value: "15" },
  { label: "above 20 kph (12.4 mph)", value: "20" },
  { label: "above 25 kph (15.5 mph)", value: "25" },
  { label: "above 30 kph (18.6 mph)", value: "30" },
];

export const HISTORY_EVENTS_STATUS_OPTIONS = [
  // new list of events updated 8/17/2025
  { label: "Cellphone Usage", value: "63588" },
  { label: "Collision", value: "63809" },
  { label: "Distracted Driving", value: "63595" },
  { label: "Driver Fatigue", value: "63592" },
  { label: "Front Collision Warning", value: "63936" },
  { label: "Lane Departure", value: "63857" },
  { label: "Manual Video Request", value: "64864" },
  { label: "Obstructed Camera", value: "63623" },
  { label: "Panic", value: "63553" },
  { label: "Pedestrian Collision Warning", value: "63943" },
  { label: "Plow Start", value: "63605" },
  { label: "Plow Stop", value: "63606" },
  { label: "Railroad Crossing Notification", value: "63860" },
  { label: "Rolling Stop", value: "63858" },
  { label: "School Zone Speed Violation", value: "61813" },
  { label: "Seatbelt Off", value: "62698" },
  { label: "Smoking", value: "63587" },
  { label: "Speed Camera Notification", value: "61814" },
  { label: "Standby Enter", value: "62704" },
  { label: "Standby Exit", value: "62714" },
  { label: "Stop and Go", value: "63862" },
  { label: "Tailgating", value: "63535" },

  // list of events prior to 7/18/2025
  // { value: "61813", label: "School Zone Speed Notification" },
  // { value: "61814", label: "Speed Camera Notification" },
  // { value: "62698", label: "SeatbeltOff" },
  // { value: "62704", label: "CameraPowerON" },
  // { value: "62714", label: "Camera Enter Standby" },
  // { value: "63535", label: "Driver Tailgating" },
  // { value: "63553", label: "Panic Alert" },
  // { value: "63587", label: "Smoking and Driving" },
  // { value: "63588", label: "Cellphone Usage Usage" },
  // { value: "63592", label: "Driver Fatigued" },
  // { value: "63598", label: "Valid Badge" },
  // { value: "63623", label: "Driver's View Obstructed" },
  // { value: "63809", label: "Impact Event ALERT!!!!" },
  // { value: "63857", label: "Lane Departure" },
  // { value: "63858", label: "Rolling Stop" },
  // { value: "63860", label: "Railroad Crossing Notification" },
  // { value: "63862", label: "Stop and Go" },
  // { value: "63936", label: "Front Collision Warning" },
  // { value: "63943", label: "Pedestrian Collision Warning" },
  // { value: "64864", label: "Media Requested" },

  // list of events prior to 7/18/2025 - sorted
  // Camera Enter Standby	62714
  // CameraPowerON	62704
  // Cellphone Usage Usage	63588
  // Driver Fatigued	63592
  // Driver Tailgating	63535
  // Driver's View Obstructed	63623
  // Front Collision Warning	63936
  // Impact Event ALERT!!!!	63809
  // Lane Departure	63857
  // Media Requested	64864
  // Panic Alert	63553
  // Pedestrian Collision Warning	63943
  // Railroad Crossing Notification	63860
  // Rolling Stop	63858
  // School Zone Speed Notification	61813
  // SeatbeltOff	62698
  // Smoking and Driving	63587
  // Speed Camera Notification	61814
  // Stop and Go	63862
  // Valid Badge	63598
];

export const RENAMED_EVENTS = [
  {
    backendValue: "Impact Event ALERT!!!!",
    displayValue: "Possible Impact",
  },
  {
    backendValue: "Impact Event ALERT",
    displayValue: "Possible Impact",
  },
];

export const IGNORED_EVENTS = ["CameraPowerON"];

export enum RECORDING_TYPE {
  sideBySide = "Side-By-Side",
  seperate = "Separate",
}

export const MEDIA_OPTIONS = [
  { label: "Video", value: "video" },
  { label: "Snapshot", value: "snapshot" },
];

export const SPEEDING_OPTIONS = [
  { label: "Minor (Orange): Over 0-10 kph (0-6.2 mph)", value: "minor" },
  { label: "Moderate (Red): Over 10-12 kph (6.2-7.5 mph)", value: "moderate" },
  { label: "Severe (Deep Red): Over 20+ kph (12.4+ mph)", value: "severe" },
  { label: "Off", value: "off" },
];
